import React, { memo } from "react"
import { twJoin } from "tailwind-merge"
import Layout from "@layouts/Layout"
import { NextSeoTraqq } from "@components/Seo"
import { Navigation } from "@layouts/NavigationV2"

const ComingSoon = () => (
  <Layout
    title={"Coming soon"}
    description={""}
    additionalMetaTags={""}
    defaultSeoConfig={""}
  >
      <NextSeoTraqq
        noindex={true}
        nofollow={true}
      />
      <Navigation
          staticTheme="dark"
          actionTheme="dark"
      />
      <div
        className={twJoin(
          "p-20p",
          "text-center",
          "flex flex-col gap-24p justify-center items-center w-full h-[calc(100vh_-_90px)]",
          "bg-neutral2-900",
          "relative"
        )}
      >
          <div
            className={twJoin(
              "absolute",
              "w-full",
              "mx-auto",
              "max-w-[1280px]",
              "h-[200px]",
              "left-[50%]",
              "translate-x-[-50%]",
              "blur-[160px]",
              "bg-[linear-gradient(95.96deg,_rgba(141,_110,_255,_0.3)_0%,_rgba(232,_57,_255,_0.3)_100.43%)]"
            )}
          />
          <h1
            className={twJoin(
              "text-32p",
              "1024:text-48p",
              " font-700 leading-[100%] text-neutral2-50 tracking-[-1%]",
              "relative"
            )}
          >
              Coming soon
          </h1>
          <div className={twJoin("text-neutral2-300", "relative")}>
              We are working hard to bring you something amazing. Stay tuned!
          </div>
      </div>
  </Layout>
)

export default memo(ComingSoon)
